module.exports = __webpack_public_path__ + "static/media/feature-not-found.1307da52.svg";